// import { styled, useTranslation } from '@obvio/app'
import { css, styled } from '@obvio/app'
import { CategoryCarousel, ProductSeo, RichText } from '@obvio/template'
import { Section } from '@obvio/ui'

import { StoreLayout } from './StoreLayout'
import { StoreProductHero } from './StoreProductHero'

import type { HeroProduct } from './StoreProductHero'
import type { ReactElement } from 'react'

const Recommended = styled(Section)`
  max-width: calc(100% - 2.5rem) !important;
  width: 88rem;
  display: flex;
  flex-direction: column;
`

const RichTextWrap = styled.div`
  margin: 0 auto;
  margin-bottom: ${(theme) => theme.spacing.extraLarge};
`

const Info = styled.span`
  display: block;
  text-align: center;
  margin-bottom: ${(theme) => theme.spacing.medium};
`

export type ProductPageProps = {
  product: HeroProduct
  recommendedCategory: { slug: string }
}

const outerCss = css`
  > div {
    margin: unset;
    max-width: 100% !important;
    width: unset;
    padding: 0 0 !important;
  }
`

export function ProductPage({
  product,
  recommendedCategory,
}: ProductPageProps): ReactElement {
  // const { t } = useTranslation()
  return (
    <>
      <ProductSeo product={product} />
      <StoreLayout>
        <Section outerCss={outerCss}>
          <StoreProductHero product={product} />
        </Section>
        <Recommended>
          <Info>511 GIFT SHOP</Info>
          <RichTextWrap>
            <RichText value="<F1>POLECAMY<F1><F2>TAKŻE:<F2>" />
          </RichTextWrap>
          <CategoryCarousel slug={recommendedCategory.slug} />
        </Recommended>
      </StoreLayout>
    </>
  )
}
